import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  TextField,
} from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { DurationComponent, SelectComponent } from '@/components/common';
import { useExtSimContext } from '@/contexts/ExtSimContext';
import { useVariableContext } from '@/contexts/VariableContext';
import { convertToISOString } from '@/utils/util-functions';
import { useActionFormContext } from '../ActionFormContext';
import 'react-duration-control/dist/react-duration-control.css';

export const ExtSimulation: React.FC = () => {
  const {
    sim3DMessage,
    extSim,
    openSimVarParams,
    sim3DModelRef,
    sim3DConfigData,
    simEndTime,
    setSim3DMessage,
    setExtSim,
    setOpenSimVarParams,
    setSim3DModelRef,
    setSim3DConfigData,
    setSimEndTime,
  } = useActionFormContext();
  const { extSimList } = useExtSimContext();
  const { variableList } = useVariableContext();
  const extSimVariables = variableList.value.filter(
    variable => variable.varScope === 'gt3DSim' && variable.type === 'string',
  );
  // const simEndTimeDuration = dayjs.duration(simEndTime);
  const [milliseconds, setMilliseconds] = useState(0);
  const simTypeOptions = [
    { value: 'atCompModify', label: 'Comp Modify' },
    { value: 'atOpenSim', label: 'Open Sim' },
    { value: 'atCancelSim', label: 'Cancel Sim' },
    { value: 'atPing', label: 'Ping' },
  ];

  useEffect(() => {
    if (simEndTime) {
      const simEndTimeDuration = moment.duration(simEndTime);
      setMilliseconds(simEndTimeDuration.asMilliseconds());
    }
  }, [simEndTime]);

  const handleDurationChange = (value: number) => {
    setMilliseconds(value);
    setSimEndTime(convertToISOString(value));
  };

  return (
    <Box display="flex" flexDirection="column">
      <SelectComponent
        value={sim3DMessage}
        label="Sim Action"
        setValue={setSim3DMessage}
      >
        {simTypeOptions.map((item, index) => (
          <MenuItem value={item.value} key={index}>
            {item.label}
          </MenuItem>
        ))}
      </SelectComponent>
      <SelectComponent value={extSim} label="External Sim" setValue={setExtSim}>
        {extSimList.value.map(item => (
          <MenuItem value={item.name} key={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </SelectComponent>

      {sim3DMessage === 'atOpenSim' ? (
        <Box mt={2} display="flex" flexDirection="column">
          <DurationComponent
            milliseconds={milliseconds}
            handleDurationChange={handleDurationChange}
          />
          <FormControlLabel
            sx={{ mt: 2 }}
            control={
              <Checkbox
                sx={{ p: '0 9px' }}
                checked={openSimVarParams}
                onChange={e => {
                  setOpenSimVarParams(e.target.checked);
                }}
              />
            }
            label="Use variable for items below"
          />

          {openSimVarParams ? (
            <div>
              <SelectComponent
                value={sim3DModelRef}
                label="Model Reference (Optional)"
                setValue={setSim3DModelRef}
                fullWidth
              >
                {extSimVariables.map((item, index) => (
                  <MenuItem value={item.name} key={index}>
                    <em>{item.name}</em>
                  </MenuItem>
                ))}
              </SelectComponent>
              <SelectComponent
                value={sim3DConfigData}
                label="Config Data (Optional)"
                setValue={setSim3DConfigData}
                fullWidth
              >
                {extSimVariables.map((item, index) => (
                  <MenuItem value={item.name} key={index}>
                    <em>{item.name}</em>
                  </MenuItem>
                ))}
              </SelectComponent>
            </div>
          ) : (
            <div>
              <br />
              <TextField
                label="Model Reference (Optional)"
                value={sim3DModelRef}
                size="small"
                fullWidth
                onChange={e => {
                  setSim3DModelRef(e.target.value);
                }}
              />
              <br />
              <br />
              <TextField
                label="Config Data (Optional)"
                value={sim3DConfigData}
                size="small"
                fullWidth
                onChange={e => {
                  setSim3DConfigData(e.target.value);
                }}
              />
            </div>
          )}
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
